/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Turkish (Turkey)
export default {
  'feedback-collector.anonymous': 'Bu geri bildirim anonim olarak gönderilir. Atlassian, bu geri bildirimle ilgili olarak sizinle doğrudan iletişime geçemez',
  'feedback-collector.anonymous.title': 'Anonim geri bildirim',
  'feedback-collector.can-be-contacted.label': 'Evet, Atlassian takımları Atlassian ürünlerini ve hizmetlerini iyileştirmek üzere deneyimlerimi öğrenmek için benimle iletişime geçebilir. <a>Atlassian Gizlilik Politikası</a> hükümlerini onaylıyorum.',
  'feedback-collector.cancel-button.label': 'İptal',
  'feedback-collector.default.custom.textarea.label': 'Düşüncelerinizi paylaşın',
  'feedback-collector.enrol-in-research.label': 'Ürün araştırmasına katılmak istiyorum',
  'feedback-collector.feedback-title': 'Düşüncelerinizi paylaşın',
  'feedback-collector.form.bug.label': 'Hatayı veya sorunu açıklayın',
  'feedback-collector.form.comment.label': 'Fikirlerinizi bizimle paylaşın',
  'feedback-collector.form.empty.label': 'Bir seçenek belirleyin',
  'feedback-collector.form.question.label': 'Hangi konuda bilgi almak istiyorsunuz?',
  'feedback-collector.form.suggestion.label': 'Neyin iyileştirilmesini istediğinizi bizimle paylaşın',
  'feedback-collector.option.bug.label': 'Hata bildirmek',
  'feedback-collector.option.comment.label': 'Yorum bırakmak',
  'feedback-collector.option.default.label': 'Geri bildirim seçin',
  'feedback-collector.option.default.placeholder': 'Birini seçin',
  'feedback-collector.option.question.label': 'Soru sormak',
  'feedback-collector.option.suggestion.label': 'Bir iyileştirme önermek',
  'feedback-collector.required.fields.summary': 'Gerekli alanlar yıldız işaretiyle belirtilmiştir',
  'feedback-collector.submit-button.label': 'Geri bildirim gönder',
  'feedback-collector.success-flag.description': 'Değerli geri bildirimleriniz, ürünlerimizi sürekli olarak iyileştirmemize yardımcı oluyor.',
  'feedback-collector.success-flag.title': 'Teşekkür ederiz!',
  'feedback-collector.summary-placeholder': 'Fikirlerinizi bizimle paylaşın',
  'proforma-form-builder.feedback-icon-label': 'Geri bildirim',
  'proforma-form-builder.give-feedback': 'Geri bildirim verin'
};